module.exports = __webpack_public_path__ + "static/img/end.c5d61e9c.jpg";